import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../lib/translations';
import Section from '../components/UI/Section';
import Button from '../components/UI/Button';
import { servicesCache } from '../lib/cache';

const Services = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const [services, setServices] = useState(servicesCache.data || []);

  useEffect(() => {
    servicesCache.get()
      .then(data => setServices(data))
      .catch(err => console.error("Failed to load services:", err));
  }, []);

  return (
    <div className="pt-20">
      <Section spacing="pb-12 md:pb-16 lg:pb-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-serif text-stone-900 mb-8">
            {t.services.title}
          </h1>
          <p className="text-lg text-stone-500 leading-relaxed max-w-2xl mx-auto">
            {lang === 'da'
              ? 'Jeg tilbyder specialiseret støtte til både private og professionelle. Min tilgang er funderet i Compassion Focused Therapy (CFT) og mange års klinisk erfaring.'
              : 'I offer specialized support for both individuals and professionals. My approach is grounded in Compassion Focused Therapy (CFT) and many years of clinical experience.'}
          </p>
        </div>
      </Section>

      <div className="grid grid-cols-1">
        {services.map((service, index) => (
          <div 
            key={service.id} 
            className={`grid grid-cols-1 md:grid-cols-2 ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`}
          >
            <div className={`h-[300px] md:h-[400px] lg:h-[600px] overflow-hidden ${index % 2 === 1 ? 'md:order-2' : ''}`}>
              <img 
                src={service.image?.[0] || "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/e0fa67b5-501c-4ab8-8d65-ec8fb536b073.jpg"} 
                alt={service.title[lang]}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className={`bg-taupe-50 flex flex-col items-center justify-center p-12 md:p-24 text-center ${index % 2 === 1 ? 'md:order-1' : ''}`}>
              <h2 className="text-2xl md:text-3xl font-serif text-stone-900 mb-6">{service.title[lang]}</h2>
              <div 
                className="text-stone-500 mb-10 max-w-md leading-relaxed line-clamp-4"
                dangerouslySetInnerHTML={{ __html: service.description[lang] }}
              />
              <Button to={`/services/${service.slug[lang]}`} variant="outline">
                {lang === 'da' ? 'Læs mere' : 'Read more'}
              </Button>
            </div>
          </div>
        ))}
      </div>

      <Section spacing="py-12 md:py-16 lg:py-32">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-serif text-stone-900 mb-8">
            {lang === 'da' ? 'Er du i tvivl om, hvad du har brug for?' : 'Not sure what you need?'}
          </h2>
          <p className="text-stone-500 mb-12 leading-relaxed">
            {lang === 'da'
              ? 'Du er altid velkommen til at kontakte mig for en uforpligtende samtale om, hvordan jeg bedst kan hjælpe dig.'
              : 'You are always welcome to contact me for a non-binding conversation about how I can best help you.'}
          </p>
          <Button to="/kontakt" variant="primary">
            {t.nav.contact}
          </Button>
        </div>
      </Section>
    </div>
  );
};

export default Services;
